import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Group, GroupApiResponse} from "features/model/types/groups/groupsSchema";
import {Pagination} from "features/model/types/groups/groupsLessonsSchema";


interface GroupsFilters {
    includeEnded: boolean;
}

interface GroupState {
    groups: Group[];
    pagination: Pagination;
    currentPage: number;
    pageSize: number;
    totalItems: number;
    isLoading: boolean;
    status: number;
    filters: GroupsFilters;
}

const groupsSlice = createSlice({
    name: "groups",
    initialState: {
        groups: [],
        pagination: {} as Pagination ,
        currentPage: 0,
        pageSize: 10,
        totalItems: 0,
        isLoading: true,
        status:200,
        filters: {
            includeEnded: false,
        },
    } as GroupState,
    reducers: {
        setGroups: (state, action: PayloadAction<GroupApiResponse>) => {
            const { data  } = action.payload;
            state.groups = data.items;
            state.pagination = data.pagination;
            state.totalItems = data.pagination.pageCount * state.pageSize;
            state.isLoading = false;
        },
        setGroupsCurrentPage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setGroupsError: (state, action: PayloadAction<number>) => {
            state.isLoading = false;
            state.status = action.payload
        },
        setGroupsFilters: (state, action: PayloadAction<Partial<GroupsFilters>>) => {
            state.filters = {
                ...state.filters,
                ...action.payload,
            };
        },
    },
});

export const {
    setGroups,
    setGroupsError,
    setLoading,
    setGroupsCurrentPage,
    setGroupsFilters,
} = groupsSlice.actions;
export const groupsReducer = groupsSlice.reducer;
